import { DatePicker } from 'module/ui/components/atoms/date-picker';
import { css } from 'styled-components';

export const TiptapContentStyles = css`
  .ProseMirror {
    font-family: var(--font-family);

    code {
      border-radius: 0.125rem;
      --tw-bg-opacity: 1;
      background-color: rgb(23 23 23 / var(--tw-bg-opacity));
      font-family: var(--code-font-family);
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
      caret-color: #fff;
      --tw-shadow:
        0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
      --tw-shadow-colored:
        0 10px 15px -3px var(--tw-shadow-color),
        0 4px 6px -4px var(--tw-shadow-color);
      box-shadow:
        var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    code::-moz-selection {
      background-color: hsla(0, 0%, 100%, 0.3);
    }

    code::selection {
      background-color: hsla(0, 0%, 100%, 0.3);
    }

    pre {
      margin-top: 3rem;
      margin-bottom: 3rem;
      border-radius: 0.25rem;
      border-width: 1px;
      --tw-border-opacity: 1;
      border-color: rgb(0 0 0 / var(--tw-border-opacity));
      --tw-bg-opacity: 1;
      background-color: rgb(64 64 64 / var(--tw-bg-opacity));
      padding: 1rem;
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
      caret-color: #fff;
    }

    :is(.dark pre) {
      --tw-border-opacity: 1;
      border-color: rgb(38 38 38 / var(--tw-border-opacity));
      --tw-bg-opacity: 1;
      background-color: rgb(23 23 23 / var(--tw-bg-opacity));
    }

    pre ::-moz-selection {
      background-color: hsla(0, 0%, 100%, 0.2);
    }

    pre ::selection {
      background-color: hsla(0, 0%, 100%, 0.2);
    }

    pre code {
      background-color: inherit;
      padding: 0;
      color: inherit;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-colored: 0 0 #0000;
      box-shadow:
        var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    blockquote {
      border-left: 3px solid var(--divider-strong, #d1d5db);
      margin: 0.5rem 0;
      padding-left: 1rem;
      color: var(--text-secondary);
      font-style: italic;
    }

    pre .hljs-comment,
    pre .hljs-quote {
      --tw-text-opacity: 1;
      color: rgb(163 163 163 / var(--tw-text-opacity));
    }

    pre .hljs-attribute,
    pre .hljs-link,
    pre .hljs-name,
    pre .hljs-regexp,
    pre .hljs-selector-class,
    pre .hljs-selector-id,
    pre .hljs-tag,
    pre .hljs-template-variable,
    pre .hljs-variable {
      --tw-text-opacity: 1;
      color: rgb(252 165 165 / var(--tw-text-opacity));
    }

    pre .hljs-built_in,
    pre .hljs-builtin-name,
    pre .hljs-literal,
    pre .hljs-meta,
    pre .hljs-number,
    pre .hljs-params,
    pre .hljs-type {
      --tw-text-opacity: 1;
      color: rgb(253 186 116 / var(--tw-text-opacity));
    }

    pre .hljs-bullet,
    pre .hljs-string,
    pre .hljs-symbol {
      --tw-text-opacity: 1;
      color: rgb(190 242 100 / var(--tw-text-opacity));
    }

    pre .hljs-section,
    pre .hljs-title {
      --tw-text-opacity: 1;
      color: rgb(253 224 71 / var(--tw-text-opacity));
    }

    pre .hljs-keyword,
    pre .hljs-selector-tag {
      --tw-text-opacity: 1;
      color: rgb(94 234 212 / var(--tw-text-opacity));
    }

    pre .hljs-emphasis {
      font-style: italic;
    }

    pre .hljs-strong {
      font-weight: 700;
    }

    .collaboration-cursor__caret {
      pointer-events: none;
      position: relative;
      margin-left: -1px;
      margin-right: -1px;
      overflow-wrap: normal;
      word-break: normal;
      border-right-width: 1px;
      border-left-width: 1px;
      --tw-border-opacity: 1;
      border-color: rgb(0 0 0 / var(--tw-border-opacity));
    }

    .collaboration-cursor__label {
      position: absolute;
      left: -1px;
      top: -1.4em;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      white-space: nowrap;
      border-radius: 0.25rem;
      border-top-left-radius: 0;
      padding: 0.125rem 0.375rem;
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 600;
      line-height: 1;
      --tw-text-opacity: 1;
      color: rgb(0 0 0 / var(--tw-text-opacity));
    }

    ol {
      list-style-type: decimal;
    }

    ul {
      list-style-type: disc;
    }

    ol,
    ul {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      padding: 0 2rem;
    }

    ol:first-child,
    ul:first-child {
      margin-top: 0;
    }

    ol:last-child,
    ul:last-child {
      margin-bottom: 0;
    }

    ol li,
    ol ol,
    ol ul,
    ul li,
    ul ol,
    ul ul {
      margin-top: 0.25rem;
      margin-bottom: 0.25rem;
    }

    ol p,
    ul p {
      margin-top: 0;
      margin-bottom: 0.25rem;
    }

    > ol,
    > ul {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    > ol:first-child,
    > ul:first-child {
      margin-top: 0;
    }

    > ol:last-child,
    > ul:last-child {
      margin-bottom: 0;
    }

    ul[data-type='taskList'] {
      list-style-type: none;
      padding: 0;
    }

    ul[data-type='taskList'] p {
      margin: 0;
    }

    ul[data-type='taskList'] li {
      display: flex;
    }

    ul[data-type='taskList'] li > label {
      margin-top: 0.25rem;
      margin-right: 0.5rem;
      flex: 1 1 auto;
      flex-shrink: 0;
      flex-grow: 0;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }

    ul[data-type='taskList'] li > div {
      flex: 1 1 auto;
    }

    ul[data-type='taskList'] li[data-checked='true'] {
      text-decoration-line: line-through;
    }

    .is-empty:before {
      pointer-events: none;
      float: left;
      height: 0;
      width: 100%;
      color: rgba(0, 0, 0, 0.4);
    }

    :is(.dark .is-empty):before {
      color: hsla(0, 0%, 100%, 0.4);
    }

    .tableWrapper {
      margin-top: 3rem;
      margin-bottom: 3rem;
    }

    /* TABLE / RECORD: scroll only inside .tableWrapper; do not expand the page / modal */
    .custom-section:has(.custom-section-content.TABLE),
    .custom-section:has(.custom-section-content.RECORD) {
      min-width: 0;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow-x: clip;
    }

    .custom-section-content.TABLE,
    .custom-section-content.RECORD {
      min-width: 0;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow-x: clip;
    }

    /* Single horizontal scrollport for the whole table — not on cells or nested node-view holes. */
    .custom-section-content.TABLE .tableWrapper,
    .custom-section-content.RECORD .tableWrapper {
      display: block;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      overflow-x: auto;
      overflow-y: visible;
      -webkit-overflow-scrolling: touch;
    }

    .custom-section-content.TABLE [data-node-view-content],
    .custom-section-content.RECORD [data-node-view-content] {
      display: block;
      min-width: 0;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow: visible;
      white-space: normal;
    }

    /* No .tableWrapper (readonly): scroll only this wrapper around the table, not inner cells.
       Exclude .table-cell-view (restore flex layout) and span wrappers (inline RL_CITATION, etc.). */
    .custom-section-content.TABLE
      [data-node-view-wrapper]:not(:has(.tableWrapper)):not(
        .table-cell-view
      ):not(span),
    .custom-section-content.RECORD
      [data-node-view-wrapper]:not(:has(.tableWrapper)):not(
        .table-cell-view
      ):not(span) {
      display: block;
      min-width: 0;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow-x: auto;
      overflow-y: visible;
      -webkit-overflow-scrolling: touch;
      white-space: normal;
    }

    .custom-section-content.TABLE [data-node-view-wrapper]:has(.tableWrapper),
    .custom-section-content.RECORD [data-node-view-wrapper]:has(.tableWrapper) {
      overflow: visible;
    }

    /* Rows/cells: no scroll; grow with content (undo fixed heights from generic .tiptap table rules). */
    .custom-section-content.TABLE table td,
    .custom-section-content.TABLE table th,
    .custom-section-content.RECORD table td,
    .custom-section-content.RECORD table th {
      height: auto !important;
      min-height: 32px;
      overflow: visible !important;
      vertical-align: top;
    }

    .custom-section-content.TABLE .table-cell-view,
    .custom-section-content.TABLE .table-cell-wrapper,
    .custom-section-content.RECORD .table-cell-view,
    .custom-section-content.RECORD .table-cell-wrapper {
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
    }

    .custom-section-content.TABLE table th .table-ghost span,
    .custom-section-content.RECORD table th .table-ghost span {
      overflow: visible !important;
      text-overflow: unset !important;
      white-space: normal !important;
    }

    .custom-section-content.TABLE table th > *,
    .custom-section-content.RECORD table th > * {
      height: auto !important;
    }

    .custom-section-content.TABLE table,
    .custom-section-content.RECORD table {
      width: max-content !important;
      min-width: unset !important;
      table-layout: auto !important;
    }

    /* Default column width only; no min/max — TipTap resize sets inline widths on col. */
    .custom-section-content.TABLE col,
    .custom-section-content.RECORD col {
      width: 240px;
    }

    table {
      box-sizing: border-box;
      width: 100%;
      border-collapse: collapse;
      border-radius: 0.25rem;
      margin-top: var(--spacing-03);
    }

    table td,
    table th {
      position: relative;
      min-width: 50px;
      border-width: 1px;
      padding: 0.5rem;
      text-align: left;
      vertical-align: top;
    }

    table td:first-of-type:not(a),
    table th:first-of-type:not(a) {
      margin-top: 0;
    }

    table td p,
    table th p {
      margin: 0;
      text-align: left;
      width: 100%;
    }

    table td p + p,
    table th p + p {
      margin-top: 0.75rem;
    }

    table th {
      font-weight: 700;
    }

    table .selectedCell {
      background: var(--cell-selected-background);
      border-style: none;
      outline: 1px solid var(--cyan-30);
      outline-offset: -1px;
    }

    table .tiptap-table-cell {
      cursor: pointer;
      padding: 0;

      .table-cell-view,
      .table-cell-wrapper {
        width: 100%;
        height: 100%;
        outline: none;
        padding: var(--spacing-01) var(--spacing-03);
        border: 2px solid transparent;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;

        ${DatePicker} {
          width: 100%;
          height: 100%;
          outline: 0;
          border: 0;
          padding: 0;
          background: transparent;
          align-items: start;

          .ant-picker-clear {
            display: none !important;
          }
        }
        &.focused {
          border: 2px solid var(--primary-color);
        }
      }
    }

    table tr:not(:first-child) th:first-child {
      background-color: white !important;
      color: var(--text-primary);
      font-size: var(--font-size-01);
      font-weight: var(--font-weight-semi-bold);
      line-height: var(--line-height-01);
    }

    table .grip-column,
    table .grip-row {
      position: absolute;
      z-index: 10;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.05);
    }

    table .grip-column {
      left: 0;
      top: -0.75rem;
      margin-left: -1px;
      height: 0.75rem;
      width: calc(100% + 1px);
      border-left-width: 1px;
      border-color: var(--scarlet-gray-30);
    }

    :is(.dark table .grip-column) {
      border-color: hsla(0, 0%, 100%, 0.2);
    }

    table .grip-column.selected:before,
    table .grip-column:hover:before {
      content: '';
      width: 0.625rem;
    }

    table .grip-column:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    :is(.dark table .grip-column:hover) {
      background-color: hsla(0, 0%, 100%, 0.2);
    }

    table .grip-column:hover:before {
      border-bottom: 2px;
      border-color: rgba(0, 0, 0, 0.6);
      border-style: dotted;
    }

    :is(.dark table .grip-column:hover):before {
      border-color: hsla(0, 0%, 100%, 0.6);
    }

    table .grip-column.first {
      border-top-left-radius: 0.125rem;
      border-color: transparent;
    }

    table .grip-column.last {
      border-top-right-radius: 0.125rem;
    }

    table .grip-column.selected {
      border-color: rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.3);
      --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
      box-shadow:
        var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    :is(.dark table .grip-column.selected) {
      border-color: hsla(0, 0%, 100%, 0.3);
      background-color: hsla(0, 0%, 100%, 0.3);
    }

    table .grip-column.selected:before {
      border-bottom-width: 2px;
      border-style: dotted;
    }

    table .grip-row {
      left: -0.75rem;
      top: 0;
      margin-top: -1px;
      height: calc(100% + 1px);
      width: 0.75rem;
      border-top-width: 1px;
      border-color: rgba(0, 0, 0, 0.2);
    }

    :is(.dark table .grip-row) {
      border-color: hsla(0, 0%, 100%, 0.2);
    }

    table .grip-row.selected:before,
    table .grip-row:hover:before {
      height: 0.625rem;
      content: '';
    }

    table .grip-row:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    :is(.dark table .grip-row:hover) {
      background-color: hsla(0, 0%, 100%, 0.2);
    }

    table .grip-row:hover:before {
      border-left: 2px;
      border-color: rgba(0, 0, 0, 0.6);
      border-style: dotted;
    }

    :is(.dark table .grip-row:hover):before {
      border-color: hsla(0, 0%, 100%, 0.6);
    }

    table .grip-row.first {
      border-top-left-radius: 0.125rem;
      border-color: transparent;
    }

    table .grip-row.last {
      border-bottom-left-radius: 0.125rem;
    }

    table .grip-row.selected {
      border-color: rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.3);
      --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
      box-shadow:
        var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    :is(.dark table .grip-row.selected) {
      border-color: hsla(0, 0%, 100%, 0.3);
      background-color: hsla(0, 0%, 100%, 0.3);
    }

    table .grip-row.selected:before {
      border-left-width: 2px;
      border-style: dotted;
    }

    p {
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
      line-height: 1.625;
    }

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }

    > p {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
    }

    > p:first-child {
      margin-top: 0;
    }

    > p:last-child {
      margin-bottom: 0;
    }

    h1 {
      font-size: 1.875rem;
      line-height: 2.25rem;
    }

    h2 {
      font-size: 1.5rem;
      line-height: 2rem;
    }

    h3 {
      font-size: 1.25rem;
      line-height: 1.75rem;
    }

    h4 {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    h5 {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    h6 {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    a.link {
      font-weight: 800;
      --tw-text-opacity: 1;
      color: rgb(59 130 246 / var(--tw-text-opacity));
    }

    :is(.dark a.link) {
      --tw-text-opacity: 1;
      color: rgb(96 165 250 / var(--tw-text-opacity));
    }

    mark {
      border-radius: 0.125rem;
      --tw-bg-opacity: 1;
      background-color: rgb(239 68 68 / var(--tw-bg-opacity));
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
      padding: 0.25rem 0;
      color: inherit;
    }

    :is(.dark mark) {
      --tw-bg-opacity: 1;
      background-color: rgb(248 113 113 / var(--tw-bg-opacity));
    }

    img {
      height: auto;
      width: 100%;
      max-width: 100%;
    }

    [data-type='horizontalRule'] {
      margin-top: 2rem;
      margin-bottom: 2rem;
      cursor: pointer;
      padding-top: 1rem;
      padding-bottom: 1rem;
      transition-property: all;
      transition-duration: 0.1s;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      animation-duration: 0.1s;
      animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }

    [data-type='horizontalRule'].ProseMirror-selectednode {
      background-color: rgba(0, 0, 0, 0.05);
    }

    :is(.dark [data-type='horizontalRule'].ProseMirror-selectednode) {
      background-color: hsla(0, 0%, 100%, 0.1);
    }

    [data-type='horizontalRule'].ProseMirror-selectednode hr {
      border-top-color: rgba(0, 0, 0, 0.3);
    }

    :is(.dark [data-type='horizontalRule'].ProseMirror-selectednode hr) {
      border-top-color: hsla(0, 0%, 100%, 0.3);
    }

    [data-type='horizontalRule']:hover:not(
        [data-type='horizontalRule'].ProseMirror-selectednode
      ) {
      background-color: rgba(0, 0, 0, 0.05);
    }

    :is(
      .dark
        [data-type='horizontalRule']:hover:not(
          [data-type='horizontalRule'].ProseMirror-selectednode
        )
    ) {
      background-color: hsla(0, 0%, 100%, 0.1);
    }

    [data-type='horizontalRule'] hr {
      border-width: 1px 0 0;
      border-color: rgba(0, 0, 0, 0.2);
      background-color: rgba(0, 0, 0, 0.8);
    }

    :is(.dark [data-type='horizontalRule'] hr) {
      border-color: hsla(0, 0%, 100%, 0.2);
      background-color: hsla(0, 0%, 100%, 0.8);
    }

    [data-type='emoji'] {
      display: inline-block;
    }

    [data-type='emoji'] img {
      width: 1em;
      height: 1em;
      -o-object-fit: cover;
      object-fit: cover;
      display: block;
    }

    .resize-cursor {
      cursor: col-resize;
    }

    .ProseMirror-gapcursor {
      position: relative;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      max-width: 42rem;
    }

    .ProseMirror-gapcursor:after {
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      max-width: 42rem;
      border-top-color: rgba(0, 0, 0, 0.4);
    }

    :is(.dark .ProseMirror-gapcursor):after {
      border-top-color: hsla(0, 0%, 100%, 0.4);
    }
    &.ProseMirror-hideselection *::selection {
      color: inherit;
    }

    &.ProseMirror-focused {
      outline: none;
    }

    .inspector-label {
      position: absolute;
      top: -20px;
      left: 0;
      background: #000;
      color: #fff;
      font-size: 10px;
      padding: 2px 4px;
      border-radius: 3px;
    }
  }
  .tiptap :first-child {
    margin-top: 0;
  }

  .tiptap table {
    border-collapse: collapse;
    margin: 0;
    margin-top: var(--spacing-03);
    overflow-x: scroll;
    table-layout: fixed;
    width: 100%;
    border-left: 1px solid var(--scarlet-gray-30);
    font-size: var(--font-size-base);

    p {
      font-size: var(--font-size-base);
    }
  }

  .tiptap table tr td {
    background-color: white !important;
  }

  .tiptap table tr {
    border-left: 1px solid var(--scarlet-gray-30);
  }

  .tiptap table td,
  .tiptap table th {
    border: none;
    border-top: 1px solid var(--scarlet-gray-30);
    border-bottom: 1px solid var(--scarlet-gray-30);
    border-right: 1px solid var(--scarlet-gray-30);
    box-sizing: border-box;
    position: relative;
    vertical-align: top;
    height: 32px;
    padding: var(--spacing-01) var(--spacing-03);
  }

  .cell-typing {
    background-color: var(--blue-10);
  }

  .tiptap table td > *,
  .tiptap table th > * {
    margin-bottom: 0;
  }

  .tiptap table th > * {
    height: 100%;
  }

  .tiptap table th .table-ghost,
  .tiptap table th .table-ghost-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    gap: var(--spacing-03);
    color: var(--text-tertiary);
    line-height: var(--line-height-05);

    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;
    }
  }

  // Override centering styles for table cell content
  .tiptap table .table-cell-view[data-type='TEXT'] {
    justify-content: flex-start !important;
    align-items: flex-start !important;
    text-align: left !important;
  }

  .tiptap table th {
    font-size: var(--font-size-01);
    font-weight: var(--font-weight-semi-bold);
    line-height: var(--line-height-01);
    // font-weight: 600;
    text-align: left;
    height: 18px;
    // font-size: 14px;
    // line-height: 18px;
    color: var(--text-primary);
  }

  .tiptap table tr:nth-child(1) th .column-resize-handle {
    background-color: var(--blue-70);
    bottom: -2px;
    pointer-events: none;
    position: absolute;
    right: -2px;
    top: 0;
    width: 4px;
  }

  .tiptap .tableWrapper {
    margin: 1.5rem 0;
    overflow-x: auto;
  }

  .tiptap .custom-section:has(.custom-section-content.TABLE),
  .tiptap .custom-section:has(.custom-section-content.RECORD) {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-x: clip;
  }

  .tiptap .custom-section-content.TABLE,
  .tiptap .custom-section-content.RECORD {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-x: clip;
  }

  .tiptap .custom-section-content.TABLE .tableWrapper,
  .tiptap .custom-section-content.RECORD .tableWrapper {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
  }

  .tiptap .custom-section-content.TABLE [data-node-view-content],
  .tiptap .custom-section-content.RECORD [data-node-view-content] {
    display: block;
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
    white-space: normal;
  }

  .tiptap
    .custom-section-content.TABLE
    [data-node-view-wrapper]:not(:has(.tableWrapper)):not(.table-cell-view):not(
      span
    ),
  .tiptap
    .custom-section-content.RECORD
    [data-node-view-wrapper]:not(:has(.tableWrapper)):not(.table-cell-view):not(
      span
    ) {
    display: block;
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    white-space: normal;
  }

  .tiptap
    .custom-section-content.TABLE
    [data-node-view-wrapper]:has(.tableWrapper),
  .tiptap
    .custom-section-content.RECORD
    [data-node-view-wrapper]:has(.tableWrapper) {
    overflow: visible;
  }

  .tiptap .custom-section-content.TABLE table td,
  .tiptap .custom-section-content.TABLE table th,
  .tiptap .custom-section-content.RECORD table td,
  .tiptap .custom-section-content.RECORD table th {
    height: auto !important;
    min-height: 32px;
    overflow: visible !important;
    vertical-align: top;
  }

  .tiptap .custom-section-content.TABLE .table-cell-view,
  .tiptap .custom-section-content.TABLE .table-cell-wrapper,
  .tiptap .custom-section-content.RECORD .table-cell-view,
  .tiptap .custom-section-content.RECORD .table-cell-wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .tiptap .custom-section-content.TABLE table th .table-ghost span,
  .tiptap .custom-section-content.RECORD table th .table-ghost span {
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: normal !important;
  }

  .tiptap .custom-section-content.TABLE table th > *,
  .tiptap .custom-section-content.RECORD table th > * {
    height: auto !important;
  }

  .tiptap .custom-section-content.TABLE table,
  .tiptap .custom-section-content.RECORD table {
    width: max-content !important;
    min-width: unset !important;
    table-layout: auto !important;
  }

  .tiptap .custom-section-content.TABLE col,
  .tiptap .custom-section-content.RECORD col {
    width: 240px;
  }

  .tiptap.resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
`;
